module.exports = __webpack_public_path__ + "static/media/gear-junkie-logo.7af5d0f6.svg";